export const GRAPHQL_VARIABLES = {
  _id: '5fbdb1a50c228f35dd575a37'
};

export const QUERY = `
    query getCompanyRoles ($_id: MongoID!) {
        getCompanyRoles (_id: $_id) {
            _id
            name
            permissions
            users
            userObjs {
                _id
                firstName
                lastName
                email
            }
        }
    }
`;
